<div class="container">
  <div class="row">
    <div class="col-md-6 m-t-40 m-b-10">
      <h2>{{ 'login.create.title' | translate }}</h2>
      <p>{{ 'login.create.description' | translate }}</p>
    </div>
    <div class="col-md-6 m-t-40 m-b-10">
      <h2>Register</h2>
      <form [formGroup]="registerForm" (ngSubmit)="register()">
        <div class="form-group">
          <label for="firstname">First Name</label>
          <input type="text" class="form-control" formControlName="firstname"
            [ngClass]="{ 'is-invalid': submitted && f.firstname.errors }" />
          @if (submitted && f.firstname.errors) {
            <div class="invalid-feedback">
              @if (f.firstname.errors.required) {
                <div>First Name is required</div>
              }
            </div>
          }
        </div>
        <div class="form-group">
          <label for="lastname">Last Name</label>
          <input type="text" class="form-control" formControlName="lastname"
            [ngClass]="{ 'is-invalid': submitted && f.lastname.errors }" />
          @if (submitted && f.lastname.errors) {
            <div class="invalid-feedback">
              @if (f.lastname.errors.required) {
                <div>Last Name is required</div>
              }
            </div>
          }
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" class="form-control" formControlName="email"
            [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
          @if (submitted && f.email.errors) {
            <div class="invalid-feedback">
              @if (f.email.errors.required) {
                <div>Email is required</div>
              }
              @if (f.email.errors.email) {
                <div>Email must be a valid email address</div>
              }
            </div>
          }
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input type="password" class="form-control" formControlName="password"
            [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
          @if (submitted && f.password.errors) {
            <div class="invalid-feedback">
              @if (f.password.errors.required) {
                <div>Password is required</div>
              }
              @if (f.password.errors.strongPassword) {
                <div>
                  Password does not meet complexity requirements
                </div>
              }
            </div>
          }
          <!-- Password strength indicator -->
          <app-password-strength [password]="f.password.value" [showRequirements]="true"></app-password-strength>
        </div>
        <div class="form-group">
          <button [disabled]="loading" class="btn btn-primary">
            @if (!loading) {
              <span>Register</span>
            }
            @if (loading) {
              <span>
                <i class="fa fa-spinner fa-spin"></i> Registering...
              </span>
            }
          </button>
          <a [routerLink]="['/login']" class="btn btn-link">Cancel</a>
        </div>
        @if (error) {
          <div class="alert alert-danger mt-3">
            {{ error }}
          </div>
        }
      </form>
    </div>
  </div>
</div>